/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * 고객 타입(1:개인, 2:법인 , 3: 외국인, 4: 개인사업자, 5: 공공기관 (Ccs Portal /getUbiSuptInfo 규격서 에서는 3:외국인, 4: 개인사업자로 구성 현재 3,4에 대한 별도 분기처리는 없어 정상동작함))
 */
export enum CustomerType {
  _1 = '1',
  _2 = '2',
  _3 = '3',
  _4 = '4',
  _5 = '5',
}
